import { el } from './dom.js';

/** 歩行・採寸・AI内見の切り替えツールバー。 */
export function createToolbar(
  container,
  { onToggleMeasure, onToggleWalk, onToggleAi, onReset, onToggleRemove, onRestore, onTogglePrice, only = null },
) {
  const walkBtn = el('button', { class: 'tool-btn', type: 'button' }, '🐹 歩く');
  const measureBtn = el('button', { class: 'tool-btn', type: 'button' }, '📐 採寸');
  const aiBtn = el('button', { class: 'tool-btn', type: 'button' }, '💬 AIに聞く');
  const resetBtn = el('button', { class: 'tool-btn', type: 'button' }, '⟲ 視点を戻す');
  // CG の物件だけ。邪魔な家具をクリックで消す
  const removeBtn = el('button', { class: 'tool-btn', type: 'button' }, '🧹 家具を消す');
  const restoreBtn = el('button', { class: 'tool-btn tool-btn-sub', type: 'button', hidden: true }, '家具を戻す');
  // 備品見積りのある物件だけ。家具をクリックすると値段が出る
  const priceBtn = el('button', { class: 'tool-btn', type: 'button' }, '💴 見積り');

  /** 押すたびに on/off が入れ替わるボタンを作る */
  const bindToggle = (button, handler) => {
    button.addEventListener('click', () => {
      const next = !button.classList.contains('is-active');
      button.classList.toggle('is-active', next);
      handler(next);
    });
  };

  bindToggle(walkBtn, onToggleWalk);
  bindToggle(measureBtn, onToggleMeasure);
  bindToggle(aiBtn, onToggleAi);
  resetBtn.addEventListener('click', onReset);
  if (typeof onToggleRemove === 'function') bindToggle(removeBtn, onToggleRemove);
  if (typeof onRestore === 'function') restoreBtn.addEventListener('click', onRestore);
  if (typeof onTogglePrice === 'function') bindToggle(priceBtn, onTogglePrice);

  /** only で明示されたときだけ出すボタン */
  const EXTRA = new Set(['remove', 'restore', 'price']);

  const readout = el('span', { class: 'tool-readout' }, '');

  /*
   * 写真モードでは歩行・採寸・視点リセットが成立しない（3Dスキャンが要る）。
   * 押せるのに何も起きないボタンを出すより、最初から出さない。
   */
  const all = [
    ['walk', walkBtn],
    ['measure', measureBtn],
    ['ai', aiBtn],
    ['reset', resetBtn],
    ['remove', removeBtn],
    ['restore', restoreBtn],
    ['price', priceBtn],
  ];
  // 家具を消すのは CG の物件だけなので、only で明示されたときだけ出す
  const shown = all
    .filter(([key]) => (only === null ? !EXTRA.has(key) : only.includes(key)))
    .map(([, node]) => node);

  const root = el('div', { class: 'toolbar' }, [...shown, readout]);
  container.appendChild(root);

  return {
    setMeasureReadout({ count, distance, missed = false }) {
      if (missed) {
        readout.textContent = '面を認識できません。壁や床の上をクリックしてください';
        return;
      }
      if (distance !== null) {
        readout.textContent = `${distance.toFixed(2)} m（${Math.round(distance * 100)} cm）`;
        return;
      }
      readout.textContent = count === 1 ? 'もう1点クリックしてください' : '';
    },
    setAiActive(active) {
      aiBtn.classList.toggle('is-active', active);
    },
    setWalkActive(active) {
      walkBtn.classList.toggle('is-active', active);
    },
    setRemoveActive(active) {
      removeBtn.classList.toggle('is-active', active);
    },
    setPriceActive(active) {
      priceBtn.classList.toggle('is-active', active);
    },
    /** 消した家具の数に応じて「家具を戻す」を出し入れする */
    setRemovedCount(count) {
      restoreBtn.hidden = count === 0;
      restoreBtn.textContent = count === 0 ? '家具を戻す' : `家具を戻す（${count}）`;
    },
    setMeasureActive(active) {
      measureBtn.classList.toggle('is-active', active);
    },
    /** 歩行中の操作説明。読み終わったら消える */
    showHint(text) {
      readout.textContent = text;
      setTimeout(() => {
        if (readout.textContent === text) readout.textContent = '';
      }, 5000);
    },
  };
}
